import { useErrorHandler, useTranslate } from '@repo/shared/hooks'
import { FormSchema, useAppForm } from '@repo/ui/hooks'

import { useLoginSchema } from '@repo/auth/schemas'
import {
  Button,
  Form,
  FormField,
  FormItemWrapper,
  Input,
} from '@repo/ui/components'
import { IChangeEmailKycFormProps } from './change-email-kyc.types'
import { useAgentEmailOtp } from '@repo/services'

export const ChangeEmailKycForm = (props: IChangeEmailKycFormProps) => {
  const { onSuccess, email } = props
  const { t } = useTranslate()
  const { emailSchema } = useLoginSchema()
  const { form } = useAppForm({
    formSchema: emailSchema,
    defaultValues: {
      email: email,
    },
  })
  const emailOtpMutation = useAgentEmailOtp()
  const { errorHandler } = useErrorHandler()

  const onSubmit = (data: FormSchema<typeof emailSchema>) => {
    emailOtpMutation.mutate(
      { email: data.email },
      {
        onSuccess: (res) => onSuccess(data.email, res?.data?.otp ?? 0),
        onError: errorHandler,
      },
    )
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className='space-y-3xl w-full'
      >
        <FormField
          control={form.control}
          name='email'
          render={({ field }) => (
            <FormItemWrapper title={t('common_email')} inputSize='lg'>
              <Input
                autoComplete='off'
                type='email'
                inputSize='lg'
                variant={'fill'}
                {...field}
              />
            </FormItemWrapper>
          )}
        />
        <Button
          className='w-full'
          type='submit'
          variant='ghost'
          size='md'
          color='base'
          loading={emailOtpMutation.isPending}
        >
          {t('common_continue')}
        </Button>
      </form>
    </Form>
  )
}
